import * as React from 'react'
import * as ReactDOM from 'react-dom'
import { LitElement } from 'lit'
import { customElement, property } from 'lit/decorators.js'
import { InfoPopover, type Position, type Size } from '../../app-core/lib/ui/InfoPopover'

/**
 * Web-component to render the InfoPopover component. The contents of the tooltip
 * should be placed as a children of this web-component with the `slot="title"` as attribute.
 */
@customElement('zaptic-info-popover')
export class InfoPopoverWrapper extends LitElement {
    @property()
    position?: Position = 'top'

    @property()
    size?: Size

    @property()
    overlayClassName?: string

    @property({ attribute: 'popover-title' })
    popoverTitle?: string

    render() {
        ReactDOM.render(
            <InfoPopover
                overlayClassName={this.overlayClassName}
                title={this.popoverTitle}
                position={this.position}
                size={this.size}
            ></InfoPopover>,
            this
        )
    }

    protected createRenderRoot() {
        return this
    }
}
